import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { InspectionTypesComponent } from './manage-inspection-type.component';

const routes: Routes = [
  { path: '', component: InspectionTypesComponent, data: { title: 'Manage Inspection Types' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageInspectionTypesRoutingModule {}

@NgModule({
  imports: [
    ManageInspectionTypesRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [InspectionTypesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ManageInspectionTypesModule {}
